// extracted by mini-css-extract-plugin
export default {"depth1":"Sidebar_depth1__Ko0-7","depth2":"Sidebar_depth2__SY1Yc","last":"Sidebar_last__z+ld+","banner":"Sidebar_banner__MTX45"};